import { useQuery } from "@tanstack/react-query";
import type {
  employeeListAPIInterface,
  employeeListFetchInterface
} from "@dealer-center/ddc-pages-employee-list-interface";

const queryKeyBase = "ddc-pages-employee-list";

export function useEmployeeListAPIInterface({
  name
}: employeeListFetchInterface) {
  return useQuery({
    queryKey: [queryKeyBase, { name }],
    queryFn: () => getFunction(name?.trim() || ""),
    enabled: !!name && name.trim().length > 0,
    retry: 1,
    staleTime: 1000 * 60 * 5 // 5 minutes
  });
}

const getFunction = async (name: string): Promise<employeeListAPIInterface> => {
  const res = await fetch("/landing/nxlambda/employeeList/" + name);
  if (res.ok) {
    return res.json();
  } else {
    throw new Error(res.statusText);
  }
};
